import {
  type ApiRoleStrategy,
  ROLES,
  api,
  stringifyQueryObj,
  useQuery,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import type { ApiLoyaltyCategory } from "../types"

export const useLoyaltyCategoryListApi = ({
  year,
  adherentId,
}: { year: number; adherentId?: string }) => {
  const { endpoint, queryKey } = useRoleConf(apiRoleConf(adherentId))
  const queryParams = stringifyQueryObj({ year })

  const { data: challengeCategories, isLoading } = useQuery({
    queryKey: [...queryKey, year],
    queryFn: () => api.get<ApiLoyaltyCategory[]>(`${endpoint}?${queryParams}`),
  })
  return {
    challengeCategories,
    loading: isLoading,
  }
}

const presidentApiRoleConf = (adherentId: string) => ({
  endpoint: `/api/loyalties/upp/adherent/${adherentId}/detailed`,
  queryKey: ["loyalties", "upp", "adherent", adherentId, "detailed"],
})

const adherentApiRoleConf = {
  endpoint: "/api/loyalties/my-adherent/detailed",
  queryKey: ["loyalties", "my-adherent", "detailed"],
}

const apiRoleConf = (adherentId?: string): ApiRoleStrategy => ({
  [ROLES.ADHERENT_HOLDER]: adherentApiRoleConf,
  [ROLES.ADHERENT_TEAM]: adherentApiRoleConf,
  ...(adherentId && {
    [ROLES.UPP_PRESIDENT]: presidentApiRoleConf(adherentId),
    [ROLES.UPP_REPRESENTATIVE]: presidentApiRoleConf(adherentId),
    [ROLES.ADMIN]: {
      endpoint: `/api/loyalties/adherent/${adherentId}/detailed`,
      queryKey: ["loyalties", "adherent", adherentId, "detailed"],
    },
    [ROLES.ADHERENT_ADVISOR]: {
      endpoint: `/api/loyalties/my-sector/adherent/${adherentId}/detailed`,
      queryKey: ["loyalties", "my-sector", "adherent", adherentId, "detailed"],
    },
  }),
})
